import { useTranslation } from "react-i18next";
import { PHOTO_PICKER_MODEL } from "../../../../components/PhotoPicker/SubComponent/Models/Models";
import { useState } from "react";
import HandleChange from "../../../../Helpers/HandleChange";
import {MarkOrderAsDelivered} from "../../../../reduxToolkit/Providers/providersApi";
import {toast} from "react-toastify";
import {errorMsg} from "../../../../Apis/functions";
import {useDispatch} from "react-redux";
import {DELIVERY_ORDER_MODEL} from "../Model/Model";
import {ACTION_MODEL} from "../../../../Helpers/ActionModel";
/**
 *
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend Developer - IBL
 * @Email: sgarcia@ibl.mx
 */
const DeliveryModalApp = ({ onHide, itemSelected, setModified }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [emptyFields, setEmptyFields] = useState(false); // Indicates if required fields are empty
    const [disabled, setDisabled] = useState(false); // Controls disabled state of the form
    const [selectedList, setSelectedList] = useState([]); // List of selected items
    const [photoPicker, setPhotoPicker] = useState({ ...PHOTO_PICKER_MODEL }); // Photo picker state
    const [item, setItem] = useState({ ...DELIVERY_ORDER_MODEL, id: itemSelected?.id }); // Delivery record model state
    const { handleChange } = HandleChange({ model: item, setModel: setItem }); // Input change handler
    const supplierId = sessionStorage.getItem('providerId');

    // Confirms the form submission
    const handleConfirm = async () => {
          if (!item.isValid({ photoPicker })) {
            setEmptyFields(true);
            return;
        }
        const files = photoPicker.listFiles;
        await dispatch(MarkOrderAsDelivered(item.toRegister({ files, receivers: selectedList.map(e=> e.userId) })))
            .then(({payload: { data: { success, code }}}) => {
            if(success){
                toast.success(t("has_been_delivered_successfully"));
                handleClear(ACTION_MODEL.HIDE);
                onHide();
                setModified(true);
            }else errorMsg(code);
        })
    };

    // Clears all form data
    const handleClear = (action) => {
        DELIVERY_ORDER_MODEL.clear();
        setItem({
            ...DELIVERY_ORDER_MODEL,
            id: action === ACTION_MODEL.HIDE ? null: itemSelected.id
        });
        setSelectedList([]);
        setEmptyFields(false);
        setPhotoPicker({ ...PHOTO_PICKER_MODEL });
    };

    return {
        t,
        handleConfirm,
        handleClear,
        photoPicker,
        setPhotoPicker,
        emptyFields,
        disabled,
        item,
        handleChange,
        selectedList,
        setSelectedList,
        supplierId
    };
};

export default DeliveryModalApp;
